const initialState = 2;
export const version = initialState;
const versionReducer = (state = initialState, action) => {
  switch (action.type) {
  default:
    return state;
  }
};
export default versionReducer;



// WEBPACK FOOTER //
// ./src/reducers/versionReducer.js